import { checkUserCreateFestival } from '@/domain/project-festival/project-festival.selectors.ts';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  originalProjectId: number;
  newProjectName: string;
  copyImpactCo2: boolean;
  copyImpactEss: boolean;
  copyImpactEnv: boolean;
};

export const duplicateProjectFestival = createAppAsyncThunk(
  'projectFestival/duplicateProjectFestival',
  async (
    params: Params,
    { extra: { projectFestivalGateway, snackbarGateway }, getState },
  ): Promise<void> => {
    try {
      const userCanCreateFestival = checkUserCreateFestival(getState());

      if (!userCanCreateFestival) {
        snackbarGateway.error(translate('License.MaxEvent'));
        return;
      }
      await projectFestivalGateway.duplicate({
        originalProjectId: params.originalProjectId,
        newProjectName: params.newProjectName,
        copyImpactCo2: params.copyImpactCo2,
        copyImpactEss: params.copyImpactEss,
        copyImpactEnv: params.copyImpactEnv,
      });
      // we could dispatch runImpactCalculateCo2ForProject + ESS + ENV here
      // because currently the score is compute only if we open the project
      // we need to the new project id from above
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('DuplicateProject.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('DuplicateProject.Message.error'));
}
